var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8571 7H9.14286C7.95939 7 7 7.95939 7 9.14286V19.8571C7 21.0406 7.95939 22 9.14286 22H19.8571C21.0406 22 22 21.0406 22 19.8571V9.14286C22 7.95939 21.0406 7 19.8571 7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.85714C2 4.09938 2.30102 3.37266 2.83684 2.83684C3.37266 2.30102 4.09938 2 4.85714 2H16.2857C16.6646 2 17.028 2.15051 17.2959 2.41842C17.5638 2.68633 17.7143 3.04969 17.7143 3.42857C17.7143 3.80745 17.5638 4.17081 17.2959 4.43872C17.028 4.70663 16.6646 4.85714 16.2857 4.85714H5.57143C5.38199 4.85714 5.20031 4.9324 5.06635 5.06635C4.9324 5.20031 4.85714 5.38199 4.85714 5.57143V16.2857C4.85714 16.6646 4.70663 17.028 4.43872 17.2959C4.17081 17.5638 3.80745 17.7143 3.42857 17.7143C3.04969 17.7143 2.68633 17.5638 2.41842 17.2959C2.15051 17.028 2 16.6646 2 16.2857V4.85714Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Copy.397755ee878918bc25edc8d495d86a10.svg";